import { executeStandardRequest, type MusinsaStandardResponse } from '@musinsa/packages-http';
import { privateHttpClient } from '../httpClient';
import { accountInfoQueryKeys } from './queryKeys';
import type {
  ValidateAccountInfoRequest,
  ValidateAccountInfoResponse,
} from './types/ValidateAccountInfo';

export type PostValidateAccountInfoResponse = MusinsaStandardResponse<ValidateAccountInfoResponse>;

/**
 * 계좌 인증
 * 입력된 계좌 정보의 유효성을 검증합니다
 */
export const validateAccountInfo = (params: ValidateAccountInfoRequest) =>
  executeStandardRequest(() =>
    privateHttpClient.post<PostValidateAccountInfoResponse>(
      accountInfoQueryKeys.validateAccountInfo,
      params,
    ),
  );
